import { render, staticRenderFns } from "./Timeline.vue?vue&type=template&id=2f225160&scoped=true"
import script from "./Timeline.vue?vue&type=script&lang=js"
export * from "./Timeline.vue?vue&type=script&lang=js"
import style0 from "./Timeline.vue?vue&type=style&index=0&id=2f225160&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f225160",
  null
  
)

export default component.exports